import { createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7a5dade6")

_pushScopeId("data-v-7a5dade6")
const _hoisted_1 = { class: "filter__header" }
const _hoisted_2 = { class: "filter__title" }
const _hoisted_3 = {
  key: 1,
  class: "filter__action"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Inverser ")
const _hoisted_5 = /*#__PURE__*/_createVNode("i", {
  class: "icon-invert",
  title: "Click to invert selection"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Reinitialiser ")
const _hoisted_7 = /*#__PURE__*/_createVNode("i", {
  class: "icon-undo",
  title: "Click to reset this filter"
}, null, -1)
const _hoisted_8 = { class: "filter__body" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    ref: "filter",
    class: ["filter", {'filter--active': _ctx.filtering}]
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.hasTitle)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "filter__label",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)))
          }, [
            _createVNode("i", {
              class: {
                      'icon-angle-down': !_ctx.isFilterCollapsed,
                      'icon-angle-right': _ctx.isFilterCollapsed,
                      'not-visible': !_ctx.collapsible
                    }
            }, null, 2),
            _createVNode("span", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.name) + " ", 1),
              _withDirectives(_createVNode("i", {
                class: "icon-info-circled",
                title: _ctx.help
              }, null, 8, ["title"]), [
                [_vShow, _ctx.hasHelp]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isFilterCollapsed)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            (_ctx.invertible)
              ? (_openBlock(), _createBlock("span", {
                  key: 0,
                  class: "button button--action button--inverted",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.invertSelection && _ctx.invertSelection(...args)), ["stop"]))
                }, [
                  _hoisted_4,
                  _hoisted_5
                ]))
              : _createCommentVNode("", true),
            _createVNode("span", {
              class: "button button--action button--inverted",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('reset')), ["stop"]))
            }, [
              _hoisted_6,
              _hoisted_7
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "content", {}, undefined, true)
    ], 512), [
      [_vShow, !_ctx.isFilterCollapsed]
    ])
  ], 2))
})